import {calculateMovieProgress} from "../web/v1/functions";

let pluralize = require('pluralize');

export default class ContentObject {

    constructor(data, constants) {
        this.data = data;
        this.constants = constants;
        this.episode = data['episode'] ? new ContentObject( data['episode'], constants ) : null;
    }

    id() {
        return this.data['id'];
    }

    kind() {
        return this.data['kind'];
    }
    hasEpisode() {
        return this.isSubseries() && this.episode;
    }

    episodeName() {
        return 'S' + this.episode.seasonNumber() + ':E' + this.episode.episodeNumber() + ' ' + this.episode.name();
    }

    seasonNumber() {
        return this.data['season_number'];
    }

    episodeNumber() {
        return this.data['episode_number'];
    }

    slug() {
        if ( this.isMovie() ) {
            return this.data['slug'];
        } else if ( this.hasEpisode() ) {
            return this.episode.data['slug'];
        }

        return null;
    }

    pathToMovie(path) {
        return path.replace( ':slug', this.slug() );
    }

    playButtonHref() {
        if ( this.isMovie() ) {
            if ( this.isLiveEvent() ) {
                return this.pathToMovie(this.constants.path.live);
            } else {
                return this.pathToMovie(this.constants.path.play);
            }
        } else if ( this.hasEpisode() ) {
            return this.episode.pathToMovie(this.constants.path.play);
        }

        return this.constants.path.void;
    }

    resumeButtonHref() {
        if ( this.isMovie() && !this.isLiveEvent() ) {
            return this.pathToMovie(this.constants.path.resume);
        } else if ( this.hasEpisode() ) {
            return this.episode.pathToMovie(this.constants.path.resume);
        }

        return this.constants.path.void;
    }

    playButtonText() {
        if ( this.isMovie() || this.hasEpisode() ) {
            if ( this.isLiveEvent() ) {
                return this.constants.text.modal.movie_details.actions.live;
            } else {
                if ( this.displayResume()  ) {
                    return this.constants.text.modal.movie_details.actions.play_from_beginning;
                } else {
                    return this.constants.text.modal.movie_details.actions.play;
                }
            }
        }

        return this.constants.text.modal.movie_details.actions.play;
    }

    thumbsUpUrl() {
        if ( this.isMovie() ) {
            return this.pathToMovie( this.constants.path.thumbs.up );
        } else if ( this.hasEpisode() ) {
            return this.episode.pathToMovie( this.constants.path.thumbs.up );
        }

        return this.constants.path.void;
    }

    thumbsDownUrl() {
        if ( this.isMovie() ) {
            return this.pathToMovie( this.constants.path.thumbs.down );
        } else if ( this.hasEpisode() ) {
            return this.episode.pathToMovie( this.constants.path.thumbs.down );
        }

        return this.constants.path.void;
    }

    isMovie() {
        return this.data['kind'] === this.constants.kind.movie;
    }

    isSubseries() {
        return this.data['kind'] === this.constants.kind.subseries;
    }

    tvodRentAmount() {
        return this.data['purchase']['rent'];
    }

    tvodBuyAmount() {
        return this.data['purchase']['buy'];
    }

    isLiveEvent() {
        return this.data['live_event'] === true;
    }

    isTVOD() {
        return ( this.isTVODBuy() || this.isTVODRent() );
    }

    isTVODObject() {
        return  this.data['tvod'] === Object( this.data['tvod'] )  && Object.keys(this.data['tvod']).length === 3 && this.data['tvod']['tvod'];
    }

    isTVODBuy() {
        return (this.data['tvod'] === true || this.isTVODObject()) && this.data['tvod_buy'] === true;
    }

    isTVODRent() {
        return (this.data['tvod'] === true || this.isTVODObject()) && this.data['tvod_rent'] === true;
    }

    activeTVOD() {
        return this.data['active_purchase'];
    }

    displayTVOD() {
        return this.userSignedIn() && this.isMovie() && this.isTVOD() && !this.activeTVOD();
    }

    watchableTVOD() {
        return this.isTVOD() && this.activeTVOD();
    }

    watchableSVOD() {
        return !this.isTVOD() && !this.data['locked'] && this.data['watchable'];
    }

    isVOD() {
        return ( this.watchableTVOD() || this.watchableSVOD() );
    }

    watchableLiveEvent() {
        return !this.isVOD() && this.isLiveEvent();
    }

    watchable() {
        return ( this.isVOD() || this.watchableLiveEvent() );
    }

    displayWatch() {
        if ( this.userSignedIn() ) {
            if ( this.isMovie() ) {
                return this.watchable();
            } else if ( this.hasEpisode() ) {
                return this.episode.watchable();
            }
        }

        return false;
    }

    resumeTime() {
        return this.data['resume_time'];
    }

    displayMovieResume() {
        return this.isMovie() && this.resumeTime() &&  this.resumeTime() > 0;
    }

    displayEpisodeResume() {
        return this.hasEpisode() && this.episode.resumeTime() &&  this.episode.resumeTime() > 0;
    }

    displayResume() {
        if ( this.userSignedIn() && ( this.displayMovieResume() || this.displayEpisodeResume() ) ) {
            let object = ( this.isMovie() ? this : this.episode );
            let movie_progress = calculateMovieProgress( object.duration(), object.resumeTime() );

            return movie_progress && movie_progress > 0;
        }

        return false;
    }

    displaySignedInUserActions() {
        return this.userSignedIn() && ( ( this.isMovie() && !this.isLiveEvent() ) || ( this.hasEpisode() ) );
    }

    onWatchlist() {
        if ( this.isMovie() ) {
            return this.data['watchlist'] === true;
        } else if ( this.hasEpisode() ) {
            return this.episode.data['watchlist'] === true;
        }

        return false;
    }

    noThumbs() {
        return !this.liked() && !this.disliked()
    }

    liked() {
        if ( this.isMovie() ) {
            return this.data['like'] === true;
        } else if ( this.hasEpisode() ) {
            return this.episode.data['like'] === true;
        }

        return false;
    }

    disliked() {
        if ( this.isMovie() ) {
            return this.data['like'] === false;
        } else if ( this.hasEpisode() ) {
            return this.episode.data['like'] === false;
        }

        return false;
    }

    displayMovieTrailer() {
        return this.isMovie() && this.data['trailer'] != null;
    }

    displayEpisodeTrailer() {
        return this.hasEpisode() && this.episode.data['trailer'] != null;
    }

    displayTrailer() {
        return this.displayMovieTrailer() || this.displayEpisodeTrailer();
    }

    trailer() {
        if ( this.displayMovieTrailer() ) {
            return this.data['trailer'];
        } else if ( this.displayEpisodeTrailer() ) {
            return this.episode.data['trailer'];
        }

        return this.constants.path.void;
    }

    suggestions() {
        if ( this.isMovie() ) {
            return this.data['suggested'];
        } else if ( this.hasEpisode() ) {
            return this.episode.data['suggested'];
        }

    }

    displaySuggestions() {
        return this.suggestions() && Array.isArray( this.suggestions() ) && this.suggestions().length > 0;
    }

    displayExtras() {
        return this.displayQuiz() || this.displayLesson() || this.activityBookHref();
    }

    displayQuiz() {
        return this.data['quiz'] === true;
    }

    displayLesson() {
        return this.data['lesson'] && this.data['lesson']['display'] === true && this.lessonHref();
    }

    activityBookHref() {
        return this.data['storybook_pdf.expiring_url'];
    }

    lessonHref() {
        return this.data['lesson_pdf.expiring_url'];
    }

    lessonTitle() {
        if ( this.data['lesson']['title'] !== null ) {
            return this.data['lesson']['title'];
        } else {
            return this.constants.text.modal.movie_details.tabs.extras.lesson.default.title;
        }
    }

    lessonDescription() {
        if ( this.data['lesson']['description'] !== null ) {
            return this.data['lesson']['description'];
        } else {
            return this.constants.text.modal.movie_details.tabs.extras.lesson.default.description;
        }
    }

    quizHref() {
        return this.pathToMovie(this.constants.path.quiz);
    }

    userSignedIn() {
        return this.data['user_id'];
    }

    displayScreenshot() {
        return this.displayMovieScreenshot() || this.displayEpisodeScreenshot();
    }

    displayMovieScreenshot() {
        return this.isMovie() && this.data['screenshot.expiring_url'];
    }

    displayEpisodeScreenshot() {
        return this.hasEpisode() && this.episode.data['screenshot.expiring_url'];
    }

    screenshot() {
        if ( this.displayMovieScreenshot() ) {
            return this.data['screenshot.expiring_url'];
        } else if ( this.displayEpisodeScreenshot() ) {
            return this.episode.data['screenshot.expiring_url'];
        } else {
            return null;
        }
    }

    name() {
        return this.data['name'];
    }

    seriesName() {
        return this.data['series_name'];
    }

    coverArt() {
        return this.data['cover_art.expiring_url'];
    }

    tvodUrl() {
        return this.constants.path.tvod.replace( ':movie_id', this.id() );
    }

    duration() {
        return this.data['duration'];
    }
    displayDuration() {
        return this.isMovie() && this.data['duration'];
    }

    seasonCount() {
        return pluralize( this.constants.text.modal.movie_details.actions.season,  this.data['seasons'].length, true );
    }
    displaySeasons() {
        return this.isSubseries() && this.data['seasons'] && this.data['seasons'].length > 0;
    }

    displayImdb() {
        return  this.data['imdb'] && this.data['imdb']['rating'] && this.data['imdb']['rating']['avg'] && this.data['imdb']['rating']['num_votes'];
    }

    imdbRating() {
        return this.data['imdb']['rating']['avg'];
    }

    imdbVotes() {
        return '(' + this.data['imdb']['rating']['num_votes'] + ')';
    }

    contentRating() {
        return this.data['content_rating'];
    }

    displayTags() {
        if ( this.isMovie() ) {
            return this.displayImdbTags() || this.displayDbTags();
        } else if ( this.hasEpisode() ) {
            return this.episode.displayImdbTags() || this.episode.displayDbTags();
        } else {
            return false;
        }
    }

    displayDbTags() {
        return this.data['tags'] && this.data['tags'].length > 0;
    }

    displayImdbTags() {
        return this.data['imdb'] && this.data['imdb']['genres'] && this.data['imdb']['genres'].length >= 3;
    }

    tags() {
        if ( this.displayTags() ) {
            if ( this.isMovie() ) {
                if ( this.displayImdbTags() ) {
                    return this.tagsFromList( this.data['imdb']['genres'] );
                } else {
                    return this.tagsFromList( this.data['tags'] );
                }
            } else if ( this.hasEpisode() ) {
                if ( this.episode.displayImdbTags() ) {
                    return this.tagsFromList( this.episode.data['imdb']['genres'] );
                } else {
                    return this.tagsFromList( this.episode.data['tags'] );
                }
            }
        }

        return null;
    }

    tagsFromList( tags_array ) {
        let tags = '';
        if  (tags_array && tags_array.length > 0 ) {
            for(let i=0; i < tags_array.length; i++) {
                tags += tags_array[i];
                let current = i +1;
                if(current !== tags_array.length) {
                    tags += '&nbsp;&nbsp;&middot;&nbsp;&nbsp;'
                }
            }
        }

        return tags;
    }

    displayMovieDescription() {
        return this.isMovie() && this.data['description'];
    }

    displayEpisodeDescription() {
        return this.hasEpisode() && this.episode.data['description'];
    }

    description() {
        if ( this.isMovie() ) {
            return this.data['description'];
        } else if ( this.hasEpisode() ) {
            return this.episode.data['description'];
        }

        return null;
    }

    onlyOneSeason() {
        return this.isSubseries() && this.seasons() && this.seasons().length === 1;
    }
    seasons() {
        return this.data['seasons'];
    }

    episodes() {
        return this.data['episodes'];
    }

    displayEpisodes() {
        return this.isSubseries() && this.data['episodes'];
    }

    titleImageUrl() {
        return this.data['title_image_url'];
    }

}
